var _module_exports = "<input ng-class=\"className\" id=\"{{ id }}\" />\n";;
var path = 'app/portainer/components/date-range-picker/date-range-picker.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;